import useGladlyRouteSync from '@/hooks/useGladlyRouteSync';

const GladlyRouteSync = () => {
  useGladlyRouteSync();
  return null;
};

export default GladlyRouteSync;
